import { ContentStatus } from '../services/contentService';
import {
  LibraryBookDifficulty,
  LibraryBookType,
  LIBRARY_BOOK_TYPE_LABELS,
  LIBRARY_DIFFICULTY_LABELS
} from '../services/libraryService';

export function normalizeLibraryBookId(raw: unknown): number | null {
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
  if (typeof raw === 'string' && raw.trim() !== '') {
    const n = Number(raw);
    if (Number.isFinite(n)) return n;
  }
  if (raw != null && typeof raw === 'object') {
    const o = raw as Record<string, unknown>;
    if ('id' in o) return normalizeLibraryBookId(o.id);
    if ('Id' in o) return normalizeLibraryBookId(o.Id);
  }
  return null;
}

export function normalizeLibraryDifficulty(raw: unknown): LibraryBookDifficulty {
  const n = typeof raw === 'number' ? raw : Number(raw);
  if (n === LibraryBookDifficulty.Intermediate) return LibraryBookDifficulty.Intermediate;
  if (n === LibraryBookDifficulty.Advanced) return LibraryBookDifficulty.Advanced;
  return LibraryBookDifficulty.Simple;
}

export function libraryDifficultyLabel(difficulty: unknown): string {
  return LIBRARY_DIFFICULTY_LABELS[normalizeLibraryDifficulty(difficulty)];
}

export function normalizeLibraryBookType(raw: unknown): LibraryBookType {
  const n = typeof raw === 'number' ? raw : Number(raw);
  if (n === LibraryBookType.New || raw === 'New' || raw === 'new') return LibraryBookType.New;
  return LibraryBookType.Classic;
}

export function libraryBookTypeLabel(bookType: unknown): string {
  return LIBRARY_BOOK_TYPE_LABELS[normalizeLibraryBookType(bookType)];
}

export function normalizePlanIds(raw: unknown): number[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((id) => (typeof id === 'number' ? id : Number(id)))
    .filter((id) => Number.isFinite(id));
}

/** API may return enum as number, string name, or stringified number. */
export function normalizeContentStatus(raw: unknown): ContentStatus {
  if (raw === ContentStatus.Published || raw === 1 || raw === '1' || raw === 'Published') {
    return ContentStatus.Published;
  }
  if (raw === ContentStatus.Archived || raw === 2 || raw === '2' || raw === 'Archived') {
    return ContentStatus.Archived;
  }
  return ContentStatus.Draft;
}

export function isLibraryBookPublished(status: unknown): boolean {
  return normalizeContentStatus(status) === ContentStatus.Published;
}
